import moduleCollapsible from '../../modules/module--collapsible';
import getBodySettings from '../global/page-settings';
import reporting from '../ui/sectors/reporting/collapsibleCb';

const { namePage } = getBodySettings('page');

export default function() {
    const instance = moduleCollapsible.add({
        block: '.collapsible-topic',
        elToggle: '.collapsible-topic__toggle',
        elContent: '.collapsible-topic__content',
        classOpenLoad: '--open-onload',
        closeOutside: false,
        closeAny: false,
        closeOthers: false,
        speed: 200,
        debug: false,
        callbackBuilt(settings) {
            return function cb() {
                if (namePage === 'reports') reporting(settings, instance);
            };
        }
    });
}
